import React, { useEffect } from 'react'
import { SectionHeader, FotterWidthButtons } from './main'
import SectionDivider from './sectionDivider'
import { func, string } from 'prop-types'
import styled from 'styled-components'
import { Box, ButtonBase } from '@material-ui/core'
import DataDeposito from './dataDeposito'
import { useDispatch } from 'react-redux'
import { activeLoading, hideLoading } from '../../../flux/loading'

const Button = styled(ButtonBase)`
  display: block;
  position: relative;
  overflow: hidden;
  background-color: var(--second);
  font-size: 1.3em;
  color: #fff;
  padding: .2em 3em;
  border-radius: 50px;
  margin: 1em auto;
`

const ButtonShadow = styled.div`
  background: red;
  height: 47px;
  position: absolute;
  width: 300px;
  opacity: 0.01;
`

const Body = styled.div`
  margin: 5em 0em;
  @media screen and (max-width: 500px) {
    text-align: center;
  }
`

const Payying = props => {
  const dispatch = useDispatch()

  // paypal config
  const paypalConfig = props => {
    return {
      createOrder: async function (data, actions) {
        dispatch(activeLoading('Estamos procesando el pago'))
        return actions.order.create({
          purchase_units: [{
            amount: { value: 2500 }
          }]
        })
      },
      onApprove: (data, actions) => {
        const status = actions.order.capture().then((details) => {
          const asyncOperation = async () => {
            await props.onApprove()
            dispatch(hideLoading())
          }
          asyncOperation()
        })
        return status
      },
      onError: () => {
        dispatch(hideLoading())
      },
      onCancel: () => {
        dispatch(hideLoading())
      }
    }
  }

  // render button paypal
  useEffect(any => {
    setTimeout(() => {
      try {
        window.document.getElementById('render_button_paypal').innerHTML = ''
        window.paypal.Buttons(paypalConfig({ ...props })).render('#render_button_paypal')
      } catch (error) { console.log('_error_', error) }
    }, 200)
  }, [props.methodPay])

  return (
    <SectionDivider step={4}>
      <SectionHeader
        title='Realiza tu pago'
      />
      <Body>
        {props.methodPay === 'paypal' && (
          <Button>
            <ButtonShadow id='render_button_paypal' />
            Pagar con paypal
          </Button>
        )}
        {props.methodPay !== 'paypal' && (
          <Box mb={3}>
            <DataDeposito />
          </Box>
        )}
        <FotterWidthButtons onBack={props.onBack} hideConfirm={props.methodPay === 'paypal'} onConfirm={props.onConfirm} justify='center' />
      </Body>
    </SectionDivider>
  )
}

Payying.propTypes = {
  methodPay: string,
  onConfirm: func,
  onBack: func,
  onApprove: func
}

export default Payying
